export default __webpack_public_path__ + "static/media/KiloBit.22f5804f.png";